module.exports = __webpack_public_path__ + "img/australia-mental-and-behavioural-disorders-female.ec62f0c3.png";